import firebase from 'firebase/app'
import 'firebase/firestore'

const firebaseConfig = {
  apiKey: "AIzaSyDNTuAfZlhUZb3WHntZah_KntsQGEiClFk",
  authDomain: "players1st.firebaseapp.com",
  databaseURL: "https://players1st.firebaseio.com",
  projectId: "players1st",
  storageBucket: "players1st.appspot.com",
  messagingSenderId: "454846191207",
  appId: "1:454846191207:web:9e534094bf0124eb4ce6c2"
};

firebase.initializeApp(firebaseConfig)

export default firebase
